import React from 'react';
import GenericModal from "../../../components/modal/GenericModal";

const CambioANoRenovacion = ({showModal, mensajeConfirmacion}) => {

    return (
        <GenericModal showModal={showModal} width={"620px"} titulo={"Nota"}>
            <div className="modal-body pt-0 pl-0">
                <div className="container-fluid">
                    {mensajeConfirmacion}
                </div>
            </div>
            <div className="modal-footer d-flex justify-content-end">
                <div className="button">
                    <button className="btn btn-primary generic-button-ficha"
                            onClick={() => showModal()}>
                        Entendido
                    </button>
                </div>
            </div>
        </GenericModal>
    )
}

export default CambioANoRenovacion